<template>
  <div class="page-card">
    <h2 class="page-title">布局设置</h2>
    <div class="settings-wrapper">
      <div class="settings-preview">
        <div class="preview-card">
          <div class="preview-window">
            <div
              class="preview-sidebar"
              :class="[`theme-${form.sidebarTheme}`, { compact: form.sidebarMode === 'compact' }]"
            >
              <div v-if="form.showLogo" class="preview-logo">TA</div>
              <div class="preview-menu">
                <span class="preview-menu-item active"></span>
                <span class="preview-menu-item"></span>
                <span class="preview-menu-item"></span>
              </div>
            </div>
            <div class="preview-main">
              <div class="preview-header" :class="`theme-${form.topbarStyle}`"></div>
              <div v-if="form.showTagsView" class="preview-tags">
                <span class="preview-tag active"></span>
                <span class="preview-tag"></span>
              </div>
              <div class="preview-content"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="settings-panel">
        <div class="setting-group">
          <div class="group-title">主题风格</div>
          <div class="setting-row">
            <div class="setting-label">主题色</div>
            <div class="theme-color-list">
              <span
                v-for="color in themeColors"
                :key="color"
                :class="['theme-color-item', { active: form.themeColor === color }]"
                :style="{ background: color }"
                @click="updateField('themeColor', color)"
              >
                <i v-if="form.themeColor === color" class="el-icon-check"></i>
              </span>
            </div>
          </div>
          <div class="setting-row">
            <div class="setting-label">顶部导航主题</div>
            <el-radio-group v-model="form.topbarStyle" size="small">
              <el-radio-button label="light">浅色</el-radio-button>
              <el-radio-button label="dark">深色</el-radio-button>
            </el-radio-group>
          </div>
          <div class="setting-row">
            <div class="setting-label">侧边栏主题</div>
            <el-radio-group v-model="form.sidebarTheme" size="small">
              <el-radio-button label="dark">深色</el-radio-button>
              <el-radio-button label="light">浅色</el-radio-button>
            </el-radio-group>
          </div>
        </div>

        <div class="setting-group">
          <div class="group-title">系统布局</div>
          <div class="setting-row">
            <div class="setting-label">侧边栏状态</div>
            <el-radio-group v-model="form.sidebarMode" size="small">
              <el-radio-button label="classic">展开</el-radio-button>
              <el-radio-button label="compact">收起</el-radio-button>
            </el-radio-group>
          </div>
          <div class="setting-row">
            <div class="setting-label">固定 Header</div>
            <el-switch v-model="form.fixedHeader" />
          </div>
        </div>

        <div class="setting-group">
          <div class="group-title">界面显示</div>
          <div class="setting-row">
            <div class="setting-label">显示 Logo</div>
            <el-switch v-model="form.showLogo" />
          </div>
          <div class="setting-row">
            <div class="setting-label">显示标签页</div>
            <el-switch v-model="form.showTagsView" />
          </div>
          <div class="setting-row">
            <div class="setting-label">动态标题</div>
            <el-switch v-model="form.dynamicTitle" />
          </div>
          <div class="setting-row">
            <div class="setting-label">实时预览</div>
            <el-switch v-model="realTimePreview" />
          </div>
        </div>

        <div class="setting-actions">
          <el-button type="primary" @click="saveSettings">保存设置</el-button>
          <el-button @click="resetSettings">恢复默认</el-button>
        </div>

        <el-alert
          title="布局设置保存在当前浏览器中，刷新页面后仍会生效。"
          type="success"
          :closable="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getDefaultLayoutSettings } from '../../utils/layout'

export default {
  name: 'LayoutSettingsPage',
  data() {
    return {
      realTimePreview: true,
      themeColors: ['#409EFF', '#13C2C2', '#722ED1', '#FA8C16', '#52C41A', '#F5222D'],
      form: getDefaultLayoutSettings()
    }
  },
  created() {
    this.form = { ...this.$store.getters.layoutSettings }
  },
  watch: {
    form: {
      deep: true,
      handler(value) {
        if (this.realTimePreview) {
          this.$store.dispatch('saveLayoutSettings', value)
        }
      }
    }
  },
  methods: {
    updateField(key, value) {
      this.form = {
        ...this.form,
        [key]: value
      }
    },
    saveSettings() {
      this.$store.dispatch('saveLayoutSettings', this.form)
      this.$message.success('布局设置已保存')
    },
    resetSettings() {
      this.form = getDefaultLayoutSettings()
      this.$store.dispatch('saveLayoutSettings', this.form)
      this.$message.success('已恢复默认布局')
    }
  }
}
</script>

<style scoped>
.settings-wrapper {
  display: flex;
  gap: 24px;
}

.settings-preview {
  width: 420px;
  flex-shrink: 0;
}

.preview-card {
  padding: 20px;
  border: 1px solid #ebeef5;
  border-radius: 12px;
  background: #fafcff;
}

.preview-window {
  height: 460px;
  border-radius: 14px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.08);
  display: flex;
}

.preview-sidebar {
  width: 96px;
  padding: 14px 10px;
  transition: all 0.2s ease;
}

.preview-sidebar.compact {
  width: 64px;
}

.preview-sidebar.theme-dark {
  background: #1f2d3d;
}

.preview-sidebar.theme-light {
  background: #ffffff;
  border-right: 1px solid #ebeef5;
}

.preview-logo {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  margin-bottom: 18px;
  background: var(--theme-color);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
}

.preview-menu {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.preview-menu-item {
  display: block;
  height: 12px;
  border-radius: 6px;
  background: rgba(148, 163, 184, 0.3);
}

.preview-menu-item.active {
  background: var(--theme-color);
}

.preview-main {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.preview-header {
  height: 52px;
}

.preview-header.theme-light {
  background: #ffffff;
  border-bottom: 1px solid #ebeef5;
}

.preview-header.theme-dark {
  background: #1f2d3d;
}

.preview-tags {
  height: 36px;
  padding: 8px 10px;
  border-bottom: 1px solid #ebeef5;
  display: flex;
  gap: 8px;
}

.preview-tag {
  width: 48px;
  height: 20px;
  border-radius: 10px;
  background: #e5e7eb;
}

.preview-tag.active {
  background: var(--theme-color);
}

.preview-content {
  flex: 1;
  background: linear-gradient(180deg, #f8fafc, #eef2f7);
}

.settings-panel {
  flex: 1;
}

.setting-group {
  margin-bottom: 18px;
  padding: 20px 22px;
  border: 1px solid #ebeef5;
  border-radius: 12px;
  background: #fff;
}

.group-title {
  margin-bottom: 18px;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.setting-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 42px;
  padding: 8px 0;
}

.setting-label {
  color: #606266;
}

.theme-color-list {
  display: flex;
  gap: 12px;
}

.theme-color-item {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.12);
}

.theme-color-item.active {
  transform: scale(1.08);
}

.setting-actions {
  margin-bottom: 16px;
  display: flex;
  gap: 12px;
}
</style>
